import { Button } from '@ads/components-react';
import { PlusIcon } from '@heroicons/react/24/outline';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import type { NotificationItem } from '@/features/notification';
import {
  NotificationListPanel,
  NotificationListTemplate,
  useNotificationFilters,
  useNotificationList,
} from '@/features/notification';

export const Route = createFileRoute('/_authenticated/notification/')({
  component: NotificationListPage,
});

function NotificationListPage() {
  const { t } = useTranslation('notification');
  const navigate = useNavigate();

  const { filters, updateFilters } = useNotificationFilters();
  const {
    data,
    isLoading,
    isFetching,
    isError,
    totalCount,
    currentPage,
    totalPages,
    pageSize,
    setPage,
    refetch,
  } = useNotificationList(filters);

  const handleEdit = useCallback(
    (item: NotificationItem) =>
      void navigate({ to: '/notification/$id', params: { id: item.id }, search: { step: 1 } }),
    [navigate],
  );

  const handleCreateNew = useCallback(
    () => void navigate({ to: '/notification/create' }),
    [navigate],
  );

  return (
    <NotificationListTemplate
      headerActions={
        <Button hierarchy="primary" size="md" leadingIcon={PlusIcon} onClick={handleCreateNew}>
          {t('actions.new')}
        </Button>
      }
      content={
        <NotificationListPanel
          filters={filters}
          onFiltersChange={updateFilters}
          data={data}
          isLoading={isLoading}
          isFetching={isFetching}
          isError={isError}
          onRetry={refetch}
          totalCount={totalCount}
          currentPage={currentPage}
          totalPages={totalPages}
          pageSize={pageSize}
          onPageChange={setPage}
          onEdit={handleEdit}
          onCreateNew={handleCreateNew}
        />
      }
    />
  );
}
